import actionTypes from './actionTypes';
import valuesActionCreators from './values/actionCreators';

/* General / Toggling */
const setFiltersVisibility = (isVisible) => ({
    type: actionTypes.SET_FILTER_VISIBILITY,
    payload: {
        isVisible,
    },
});

const setAppliedFilters = (appliedFilters) => ({
    type: actionTypes.SET_APPLIED_FILTERS,
    payload: {
        appliedFilters,
    },
});

const hydrateAppliedFilters = (appliedFilters) => ({
    type: actionTypes.HYDRATE_APPLIED_FILTERS,
    payload: {
        appliedFilters,
    },
});

const resetAppliedFilters = () => ({
    type: actionTypes.RESET_APPLIED_FILTERS,
    payload: {},
});

export default {
    setFiltersVisibility,
    setAppliedFilters,
    hydrateAppliedFilters,
    resetAppliedFilters,
    ...valuesActionCreators,
};
